export default "__VITE_ASSET__ZKJWcS6L__";